import { VFC } from "react";
import { Game, GameStatus } from "../../../../utils/Game";
import { DocumentReference } from "firebase/firestore";
import { GameMasterStatusWaitForMembers } from "./GameMasterStatusWaitForMembers";
import { GameMasterStatusWaitForNames } from "./GameMasterStatusWaitForNames";
import { ActivePlayerAnzeige } from "../ActivePlayerAnzeige/ActivePlayerAnzeige";

export const GameMaster: VFC<{
  game?: Game;
  gameRef: DocumentReference;
  small: boolean;
}> = ({ game, gameRef, small }) => {
  switch (game?.status) {
    case GameStatus.WAIT_FOR_MEMBERS:
      return (
        <GameMasterStatusWaitForMembers
          small={small}
          game={game!}
          gameRef={gameRef}
        />
      );

    case GameStatus.WAIT_FOR_INVENTED_NAME:
      return (
        <GameMasterStatusWaitForNames
          small={small}
          gameRef={gameRef}
          game={game}
        />
      );

    case GameStatus.PLAY:
      return <ActivePlayerAnzeige small={small} />;

    default:
      return null;
  }
};
